export const NAME = 'modals';
